import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import withContent from '../../../containers/withContent';
import copContent from '../Content/cop.content';
import { StatusBanner } from 'web-ui-components/lib/layout/content';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { hasApiCallInProgress } from '../../../states/api/selectors';

class RawMatchMade extends Component {
	constructor(props) {
		super(props);
		this.handleComplete = this.handleComplete.bind(this);
	}

	handleComplete() {
		const { copResult, handleComplete, hasApiCallInProgress, scanDetails } = this.props;

		if (hasApiCallInProgress) {
			return;
		}

		handleComplete(copResult, scanDetails);
	}

	render() {
		const { content, hasApiCallInProgress, isPayeeSaved, isSingleUse } = this.props;
		const { matchMadeText, matchMadeAndSavedText, continueButtonText, match_made_heading, match_made_header_detail } =
			content;
		const primaryButton = (
			<NavigationButton.Primary
				data-test-id="match-made-continue-button"
				labelText={continueButtonText}
				isLoading={hasApiCallInProgress}
				onClick={this.handleComplete}
			/>
		);
		return (
			<div>
				<StatusBanner.Success>
					<span>{isPayeeSaved && !isSingleUse ? matchMadeAndSavedText : matchMadeText}</span>
				</StatusBanner.Success>
				<ServicingSection>
					<PageHeading data-test-id="match-made">{match_made_heading}</PageHeading>
					<p>{match_made_header_detail}</p>
					<NavigationButtonGroup primaryButton={primaryButton} />
				</ServicingSection>
			</div>
		);
	}
}

RawMatchMade.propTypes = {
	content: PropTypes.shape({}),
	handleComplete: PropTypes.func,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	isPayeeSaved: PropTypes.bool,
	isSingleUse: PropTypes.bool,
	copResult: PropTypes.object,
	scanDetails: PropTypes.shape({
		accountNumber: PropTypes.string,
		sortCode: PropTypes.string,
	}),
};

const mapStateToProps = (state) => ({
	hasApiCallInProgress: hasApiCallInProgress(state),
});

const connectWrapper = connect(mapStateToProps, null);
const contentWrapper = withContent({ content: copContent });

const MatchMade = compose(connectWrapper, contentWrapper)(RawMatchMade);

export { RawMatchMade, MatchMade };
